// extracted by mini-css-extract-plugin
export var content = "_77-3";
export var list = "_77-4";
export var settingsContent = "_77-7";
export var settingsPanel = "_77-8";
export var state = "_77-6";
export var triggerBadge = "_77-2";
export var triggerButton = "_77-1";
export var triggerShell = "_77-0";
export var unreadDot = "_77-5";